export class ConsultaMaquinaModel {
    chaveMaquina: number;
    inscricaoResponsavel: string;
    nomeMaquina: string;
    dtInicial: string;
    dtFinal: string;
    linhaInicial: string;
    linhaFinal: string;
    quantidadeLinhas: number;
    estadoMaquina: string;
    icEnvio: string;
    termoAceite: string;
    codigoUsuarioResponsavel: string;
    chaveResponsavel: number;
    termo: string;

}